import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { DateTime } from "luxon";
import { DateRange } from "react-day-picker";

const SelectedRange = ({ range }: { range: DateRange | undefined }) => {
  const formatFrom = range?.from
    ? DateTime.fromJSDate(range?.from as Date)
    : null;
  const formatTo = range?.to ? DateTime.fromJSDate(range?.to as Date) : null;

  const fromDate = formatFrom && {
    date: formatFrom.toFormat("dd"),
    month: formatFrom.toFormat("LLL"),
    year: formatFrom.toFormat("y"),
    day: formatFrom.toFormat("cccc"),
  };
  const toDate = formatTo && {
    date: formatTo.toFormat("dd"),
    month: formatTo.toFormat("LLL"),
    year: formatTo.toFormat("y"),
    day: formatTo.toFormat("cccc"),
  };

  return (
    <div className="flex items-center justify-around h-20 w-full bg-offWhite rounded-lg">
      <section className="flex flex-col justify-center items-center">
        <p className="self-start text-start text-sm font-bold text-primary">
          From
        </p>
        {fromDate !== null ? (
          <div className="flex h-8 gap-2  items-center justify-center ">
            <p className=" text-2xl font-bold  text-center">{fromDate.date}</p>
            <section className="flex flex-col">
              <p className="font-bold text-sm ">
                {fromDate.month} {fromDate.year}
              </p>
              <p className="text-xs text-darkGray font-bold ">{fromDate.day}</p>
            </section>
          </div>
        ) : (
          <p>-------</p>
        )}
      </section>
      <ArrowRightIcon className="size-6 text-primary/80 font-bold" />
      <section className="flex flex-col justify-center items-center">
        <p className="self-start text-start text-sm font-bold text-primary">
          To
        </p>
        {toDate !== null ? (
          <div className="flex h-8 gap-2  items-center justify-center ">
            <p className=" text-2xl font-bold  text-center">{toDate.date}</p>
            <section className="flex flex-col">
              <p className="font-bold text-sm ">
                {toDate.month} {toDate.year}
              </p>
              <p className="text-xs text-darkGray font-bold ">{toDate.day}</p>
            </section>
          </div>
        ) : (
          <p>-------</p>
        )}
      </section>
    </div>
  );
};

export default SelectedRange;
